import * as firebase from 'firebase';
import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { IEvent } from '../models/client.model';
import { IQuestion } from '../models/question.model';
import { INote } from '../models/notes.model';
import { INew } from '../models/news.model';
import { IStaffConfig, IStaffData } from '../models/staff.model';
import { ISponsorClient, ISponsorEvent } from '../models/sponsor';
import { IAgenda } from '../models/agenda.model';
import { ICountdown } from '../models/countdown.model';
import { UtilitiesProvider } from './utilities';
import { ENV } from '@app/env';
import { Jsonp } from '@angular/http';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class EventData {

  constructor(
    private database: AngularFireDatabase,
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private utilities: UtilitiesProvider,
    private jsonp: Jsonp,
  ) { }

  getModuleState(clientId: string, eventId: string, module: string): Observable<boolean> {
    return this.database.object<boolean>(`Clients/${clientId}/EventConfig/${eventId}/modules/${module}`).valueChanges();
  }

  getModuleConfig(clientId: string, eventId: string, module: string): Observable<boolean> {
    return this.database.object<boolean>(`Clients/${clientId}/EventConfig/${eventId}/modules_config/${module}`).valueChanges();
  }

  /**
   * Use on menu event
   * 06-03-2018
   * @param client
   * @param eventId
   */
  getEventInfo(clientId: string, eventId: string): Observable<IEvent> {
    return this.database.object<IEvent>('/Clients/' + clientId + '/EventList/' + eventId).valueChanges();
  }

  getSubEvents(clientId: string, eventId: string): Observable<IEvent[]> {
    return this.database.list<IEvent>(`/Clients/${clientId}/EventList`,
      ref => ref.orderByChild('sub_event').equalTo(eventId))
      .valueChanges();
  }

  getEventConfig(clientId: string, eventId: string): Observable<any> {
    return this.database.object<IEvent>('/Clients/' + clientId + '/EventConfig/' + eventId).valueChanges();
  }

  getEventModules(clientId: string, eventId: string): Observable<any> {
    return this.database.object<IEvent>(`/Clients/${clientId}/EventConfig/${eventId}/modules`).valueChanges();
  }

  getListEvents(client, state = true, except = false) {
    let dataReturn = [];
    let q = firebase.database().ref().child('/Clients/' + client.url + '/EventList').orderByChild('state').equalTo(state);

    return new Promise((resolve, reject) => {
      q.once('value').then((snapshot) => {
        snapshot.forEach((childSnapshot) => {
          if (except) {
            if (childSnapshot.val().id != except) {
              dataReturn.push(childSnapshot.val());
            }
          } else {
            dataReturn.push(childSnapshot.val());
          }
        });

        resolve(dataReturn);
      })
        .catch(error => {
          reject(error);
        });
    })
  }

  setTransactionDashboard(client: any, event: any, child) {
    // Increase counter dashboard event
    firebase.database().ref().child('/Clients/' + client.url + '/___Dashboard/' + event.id + '/' + child).
      transaction(function (currentCount) {
        return currentCount + 1;
      });
  }

  setTransactionOpinometer(type, client, opinometer, question, key) {
    switch (type) {
      case 'multiple':
      case 'multipleUnique':
        firebase.database().ref().child('/Clients/' + client.url + '/___OpinometerStats/' + opinometer.id + '/' + question.id + '/' + key).transaction(function (currentCount) {
          return currentCount + 1;
        });
        break;
      case 'open':
        firebase.database().ref().child('/Clients/' + client.url + '/___OpinometerStats/' + opinometer.id + '/' + question.id).transaction(function (currentCount) {
          return currentCount + 1;
        });
        break;
      case 'ranking':
        firebase.database().ref().child('/Clients/' + client.url + '/___OpinometerStats/' + opinometer.id + '/' + question.id).transaction(function (currentCount) {
          if (currentCount) {
            return (parseFloat(currentCount) + parseFloat(question.answerData)) / 2;
          } else {
            return question.answerData;
          }
        });
        break;
    }

    return true;
  }

  // IV
  setTransactionInteractiveVote(type, client, opinometer, question, key, user, pond) {
    switch (type) {
      case 'multiple':
      case 'multipleUnique':
        let voteWeight = user.interactive ? user.interactive[opinometer.id] : 1;
        if (opinometer.voteType === 'code') {
          this.utilities.consoleDecorator('Code vote weight: ', pond);
          voteWeight = pond;
        }
        firebase.database().ref().child('/Clients/' + client.url + '/___VoteStats/' + opinometer.id + '/' + question.id + '/' + key).transaction(function (currentCount) {
          return currentCount + (1 * (voteWeight / 100));
        });
        firebase.database().ref().child('/Clients/' + client.url + '/___VoteNumbers/' + opinometer.id + '/' + question.id + '/' + key).transaction(function (currentCount) {
          return (currentCount || 0) + 1;
        });
        break;
      case 'open':
        firebase.database().ref().child('/Clients/' + client.url + '/___VoteStats/' + opinometer.id + '/' + question.id).transaction(function (currentCount) {
          return currentCount + 1;
        });
        break;
      case 'ranking':
        firebase.database().ref().child('/Clients/' + client.url + '/___VoteStats/' + opinometer.id + '/' + question.id).transaction(function (currentCount) {
          if (currentCount) {
            return (parseFloat(currentCount) + parseFloat(question.answerData)) / 2;
          } else {
            return question.answerData;
          }
        });
        break;
    }

    return true;
  }

  //IV
  changeCodeVoteStatus(client, voteId, codes) {
    return firebase.database().ref(`Clients/${client.url}/Votes/${voteId}/codes`).update(codes);
  }

  setShowcaseReserve(client, tokenEvent, idShowCase, idUser, data) {

    var key = firebase.database().ref('Clients/' + client.url + '/Events/' + tokenEvent + "/ShowcaseReserve").child(idShowCase).push().key;
    firebase.database().ref('Clients/' + client.url + '/Events/' + tokenEvent + "/ShowcaseReserve/" + idShowCase + '/' + key).set(data);
    firebase.database().ref('Clients/' + client.url + '/Events/' + tokenEvent + "/UserShowCaseReserve/" + idUser + '/' + key).set(data);
  }

  getShowcaseReserve(client, tokenEvent, idShowCase) {
    return this.database.list('Clients/' + client.url + '/Events/' + tokenEvent + '/ShowcaseReserve/' + idShowCase).valueChanges();
  }

  getListDiary(client, tokenEvent) {
    return this.database.list('Clients/' + client.url + '/Events/' + tokenEvent + '/Diary', ref => ref.orderByChild('state').equalTo(true)).valueChanges();
  }

  getListSponsor(client, tokenEvent) {
    return this.database.list('Clients/' + client.url + '/Events/' + tokenEvent + '/Sponsors', ref => ref.orderByChild('state').equalTo(true)).valueChanges();
  }

  getListSponsorSecond(client, tokenEvent) {
    return this.database.list('Clients/' + client.url + '/Events/' + tokenEvent + '/SponsorsSecond', ref => ref.orderByChild('state').equalTo(true)).valueChanges();
  }

  getListSpeaker(client, tokenEvent) {
    return this.database.list('Clients/' + client.url + '/Events/' + tokenEvent + '/Speakers', ref => ref.orderByChild('order')).valueChanges();
  }

  getListNews(client, tokenEvent) {
    return this.database.list('Clients/' + client.url + '/Events/' + tokenEvent + '/News', ref => ref.orderByChild('order')).valueChanges();
  }

  getListMessages(client, token_event, typeMessage) {
    return this.database.list('/Clients/' + client.url + '/Events/' + token_event + '/Messages/' + typeMessage, ref => ref.orderByChild('order')).valueChanges();
  }

  getListMessagesFooter(clientId, token_event) {
    return this.database.list('/Clients/' + clientId + '/Events/' + token_event + '/Messages/Footer', ref => ref.orderByChild('state').equalTo(true)).valueChanges();
  }

  getSpeaker(client, speakerId) {
    return this.database.object('Clients/' + client.url + '/Speakers/' + speakerId)
      .valueChanges();
  }

  getNew(client, newId) {
    return this.database.object('Clients/' + client.url + '/News/' + newId)
      .valueChanges();
  }

  getNow(client, tokenEvent) {
    return this.database.object('Clients/' + client.url + '/Events/' + tokenEvent + '/Now')
      .valueChanges();
  }

  getActivity(client, tokenEvent) {
    return this.database.object('Clients/' + client.url + '/Events/' + tokenEvent + '/Activity').valueChanges();
  }

  getStands(client, tokenEvent) {
    return this.database.list('Clients/' + client.url + '/Events/' + tokenEvent + '/Showcases').valueChanges();
  }

  getMessages(client, userSender, userAddressee) {
    return this.database.object('Clients/' + client.url + '/___NetworkingMessages/' + userSender + '/' + userAddressee).valueChanges();
  }

  getCatalogs(client, tokenEvent) {
    return this.database.list('Clients/' + client.url + '/Events/' + tokenEvent + '/Catalogs').valueChanges();
  }

  getCatalogsTop(client, tokenEvent) {
    return this.database.list('Clients/' + client.url + '/Events/' + tokenEvent + '/Catalogs', ref => ref.orderByChild('isTop').equalTo(true)).valueChanges();
  }

  getMap(client, tokenEvent) {
    return this.database.object('Clients/' + client.url + '/Events/' + tokenEvent + '/Map')
      .valueChanges();
  }

  getEmbed(client, tokenEvent) {
    return this.database.object('Clients/' + client.url + '/Events/' + tokenEvent + '/Embed').valueChanges();
  }

  getEmbedSecond(client, tokenEvent) {
    return this.database.object('Clients/' + client.url + '/Events/' + tokenEvent + '/EmbedSecond').valueChanges();
  }

  getStreaming(client, tokenEvent) {
    return this.database.object('Clients/' + client.url + '/Events/' + tokenEvent + '/Streaming').valueChanges();
  }

  getSocial(client, tokenEvent) {
    return this.database.object('Clients/' + client.url + '/Events/' + tokenEvent + '/Social').valueChanges();
  }

  public getInstagramTimeline(token: string) {
    return this.jsonp.request(`https://api.instagram.com/v1/users/self/media/recent/?access_token=${token}&callback=JSONP_CALLBACK`)
      .pipe(map((response: any) => {
        this.utilities.consoleDecorator(`Instagram data`, response)
        return response._body.data;
      }), catchError((error) => {
        this.utilities.consoleError("Instagram error", error);
        return Observable.of()
      }))
  }

  getDiary(client, tokenEvent, tokenDiary) {
    return this.database.object('Clients/' + client.url + '/Events/' + tokenEvent + '/Diary/' + tokenDiary).valueChanges()
  }

  getCatalog(client, tokenCatalog) {
    return this.database.object('Clients/' + client.url + '/Catalogs/' + tokenCatalog).valueChanges()
  }

  getEventConfigByModule(clientId: string, eventId: string, moduleName: string): Observable<any> {
    return this.database.object(`Clients/${clientId}/EventConfig/${eventId}/modules_config/${moduleName}`).valueChanges()
  }

  getPayments(client, userId) {
    return this.database.list('Clients/' + client.url + '/___PayUsers/' + userId).valueChanges();
  }

  getOpinometerPublish(client, tokenEvent) {
    return this.database.object('Clients/' + client.url + '/EventList/' + tokenEvent + '/opinometerNow').valueChanges();
  }

  getVotePublish(client, tokenEvent) {
    return this.database.object('Clients/' + client.url + '/EventList/' + tokenEvent + '/voteNow')
      .valueChanges();
  }

  getQuestionsPublish(client, tokenEvent) {
    return this.database.list('Clients/' + client.url + '/Events/' + tokenEvent + '/Question')
      .valueChanges();
  }

  getOpinometerQuestions(client, opinometerId) {
    return this.database.list('Clients/' + client.url + '/Opinometers/' + opinometerId + '/Questions')
      .valueChanges();
  }

  getVoteQuestions(client, voteId) {
    return this.database.list('Clients/' + client.url + '/Votes/' + voteId + '/Questions')
      .valueChanges();
  }

  getOpinometerStats(client, opinometerId) {
    return this.database.list('Clients/' + client.url + '/___OpinometerStats/' + opinometerId)
      .valueChanges();
  }

  getVoteStats(client, voteId) {
    return this.database.list('Clients/' + client.url + '/___VoteStats/' + voteId)
      .valueChanges();
  }

  getVoteUsers(client, voteId) {
    return this.database.list(`/Clients/${client.url}/___votesUsers/${voteId}`)
      .valueChanges();
  }

  getVoteNumbers(client, voteId) {
    return this.database.list(`/Clients/${client.url}/___VoteNumbers/${voteId}`)
      .valueChanges();
  }

  getMyContacts(client, userId) {
    return this.database.list('Clients/' + client.url + '/___NetworkingUsers/' + userId)
      .valueChanges()
  }

  getCatalogBadge(client, userId) {
    return this.database.list('Clients/' + client.url + '/___CartUsers/' + userId)
      .valueChanges();
  }

  getUser(client, userId) {
    return this.database.object('Clients/' + client.url + '/Users/' + userId)
      .valueChanges();
  }

  getData(client: any, tokenEvent: string, component: string, equalToChild: any = false) {
    let dataReturn = [];
    let dataRef;

    if (equalToChild) {
      dataRef = firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent + '/' + component).orderByChild(equalToChild.child).equalTo(equalToChild.value);
    } else {
      dataRef = firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent + '/' + component)
    }

    return new Promise((resolve, reject) => {
      dataRef.once('value').then((snapshot) => {
        snapshot.forEach((childSnapshot) => {
          dataReturn.push(childSnapshot.val());
        });

        resolve(dataReturn);
      });
    })
  }

  getSingleData(client: any, tokenEvent: string, component: string) {
    let dataRef;

    dataRef = firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent).child(component)

    return new Promise((resolve, reject) => {
      dataRef.once('value').then((snapshot) => {
        resolve(snapshot.val());
      });
    })
  }

  getDataRelated(client: any, tokenEvent: string, component: string, equalToChild: any = false, equalToChildRefered: any = false) {
    let dataReturn = [];
    let dataRef: any;
    let dataRelatedRef: any;

    if (equalToChild) {
      dataRef = firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent + '/' + component)
        .orderByChild(equalToChild.child)
        .equalTo(equalToChild.value);
    } else {
      dataRef = firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent + '/' + component);
    }

    if (equalToChildRefered) {
      dataRelatedRef = firebase.database().ref().child('/Clients/' + client.url + '/' + component).orderByChild(equalToChildRefered.child).equalTo(equalToChildRefered.value);
    } else {
      dataRelatedRef = firebase.database().ref().child('/Clients/' + client.url + '/' + component);
    }

    return new Promise((resolve, reject) => {
      dataRef.once('value')
        .then(snapshot => {
          snapshot.forEach(dataSnapshot => {
            dataRelatedRef.child(dataSnapshot.val().id).once('value')
              .then(dataSnapshot2 => {
                dataReturn.push({
                  data: dataSnapshot.val(),
                  related: dataSnapshot2.val()
                });
              }).catch(error => {
                reject(error);
              });
          });
        }).catch(error => {
          reject(error);
        });

      resolve(dataReturn);
    });
  }

  getEventMap(clientId: string, eventId: string) {
    return this.database.object(`/Clients/${clientId}/Events/${eventId}/Map`)
      .valueChanges();
  }

  getSocialConfig(clientId: string, eventId: string) {
    return this.database.object(`/Clients/${clientId}/Events/${eventId}/Social`)
      .valueChanges();
  }

  getSponsorsEvent(clientId: string, eventId: string): Observable<ISponsorEvent[]> {
    return this.database.list<ISponsorEvent>(`/Clients/${clientId}/Events/${eventId}/Sponsor`,
      ref => ref.orderByChild('state').equalTo(true))
      .valueChanges();
  }

  getSponsorEvent(clientId: string, eventId: string, sponsorId: string): Observable<ISponsorClient> {
    return this.database.object<ISponsorClient>(`/Clients/${clientId}/Events/${eventId}/Sponsor/${sponsorId}`)
      .valueChanges();
  }

  getSponsor(clientId: string, sponsorId: string) {
    return this.database.object<any>(`/Clients/${clientId}/Sponsors/${sponsorId}`)
      .valueChanges();
  }

  plusSponsorClick(clientId: string, sponsorId: string) {
    return this.database.object<any>(`/Clients/${clientId}/Sponsors/${sponsorId}/numClicks`).query.ref
      .transaction(clicks => clicks + 1);
  }

  getGeneralQuestions(clientId: string) {
    return this.database.list<IQuestion>(`/Clients/${clientId}/Questions`)
      .valueChanges();
  }

  getEventQuestions(clientId: string, eventId: string) {
    return this.database.list<IQuestion>(`/Clients/${clientId}/Events/${eventId}/Questions`)
      .valueChanges();
  }

  addQuestion(clientId: string, eventId: string, userId: string, text: string) {
    const key = this.database.createPushId();
    let url = '';
    if (this.utilities.validateEventIdParam(eventId)) {
      url = `/Clients/${clientId}/Events/${eventId}/Questions/${key}`;
    } else {
      url = `/Clients/${clientId}/Questions/${key}`;
    }
    return this.database.object(url).set({
      author: userId,
      created_at: firebase.database.ServerValue.TIMESTAMP,
      text,
      id: key
    });
  }

  likeQuestion(clientId: string, userId: string, eventId: string, questionId: string, value: boolean) {
    const like = value ? true : false;

    if (this.utilities.validateEventIdParam(eventId)) {
      return this.afs
        .collection(clientId)
        .doc('QuestionLikesEvents')
        .collection(eventId)
        .doc('Question')
        .collection(questionId)
        .doc(userId)
        .set({ like, eventId, userId, questionId }).then(() => {
          firebase.database().ref(`/Clients/${clientId}/Events/${eventId}/Questions/${questionId}/likes`)
            .transaction(current => {
              return like ? current += 1 : current -= 1;
            });
        });
    } else {
      return this.afs
        .collection(clientId)
        .doc('QuestionLikes')
        .collection(questionId)
        .doc(userId)
        .set({ like, userId, questionId }).then(() => {
          firebase.database().ref(`/Clients/${clientId}/Questions/${questionId}/likes`)
            .transaction(current => {
              return like ? current += 1 : current -= 1;
            });
        });
    }
  }

  verifiedUserLikeQuestion(clientId: string, userId: string, eventId: string, questionId: string) {
    if (this.utilities.validateEventIdParam(eventId)) {
      return this.afs
        .collection(clientId)
        .doc('QuestionLikesEvents')
        .collection(eventId)
        .doc('Question')
        .collection(questionId)
        .doc(userId).valueChanges();
    } else {
      return this.afs
        .collection(clientId)
        .doc('QuestionLikes')
        .collection(questionId)
        .doc(userId).valueChanges()
    }
  }

  getQuestionsComments(clientId: string, eventId: string, questionId: string) {
    if (this.utilities.validateEventIdParam(eventId)) {
      return this.afs
        .collection(clientId)
        .doc('QuestionCommentsEvents')
        .collection(eventId)
        .doc('Question')
        .collection(questionId).valueChanges();
    } else {
      return this.afs
        .collection(clientId)
        .doc('QuestionComments')
        .collection(questionId).valueChanges()
    }
  }

  addComment(clientId: string, questionId: string, userId: string, eventId: string, text: string) {
    const randomId = this.afs.createId();

    if (this.utilities.validateEventIdParam(eventId)) {
      return this.afs
        .collection(clientId)
        .doc('QuestionCommentsEvents')
        .collection(eventId)
        .doc('Question')
        .collection(questionId)
        .doc(randomId)
        .set({ id: randomId, text, eventId, userId, questionId }).then(() => {
          firebase.database().ref(`/Clients/${clientId}/Events/${eventId}/Questions/${questionId}/comments`)
            .transaction(current => {
              return current += 1;
            });
        });
    } else {
      return this.afs
        .collection(clientId)
        .doc('QuestionComments')
        .collection(questionId)
        .doc(randomId)
        .set({ id: randomId, text, userId, questionId }).then(() => {
          firebase.database().ref(`/Clients/${clientId}/Questions/${questionId}/comments`)
            .transaction(current => {
              return current += 1;
            });
        });
    }
  }

  getNotes(clientId: string, userId: string) {
    return this.database.list<INote>(`/Clients/${clientId}/UserNotes/${userId}`)
      .valueChanges();
  }

  async addNote(clientId: string, userId: string, text: string, images: File[], eventId?: string) {
    const key = this.database.createPushId();
    let imageList = [];
    imageList = await this.uploadImages(`/Clients/${clientId}/UserNotes/${userId}/${key}`, images);
    const note = {
      text,
      images: imageList,
      id: key,
      event: eventId ? eventId : null,
      created_at: firebase.database.ServerValue.TIMESTAMP,
      author: userId
    }
    this.database.object(`/Clients/${clientId}/UserNotes/${userId}/${key}`).set(note);

    return Promise.resolve(key);
  }

  uploadImages(path: string, images: File[]): Promise<string[]> {
    return Promise.all(images.map(image => {
      const ref = firebase.storage().ref(path).child(image.name);
      const task = ref.put(image);
      return task.then(() => task.snapshot.downloadURL);
    }));
  }

  removeNote(clientId: string, userId: string, noteId: string) {
    return this.database.object(`/Clients/${clientId}/UserNotes/${userId}/${noteId}`).remove();
  }

  getNews(clientId: string) {
    return this.database.list<INew>(`/Clients/${clientId}/News`, ref => ref.orderByChild('state').equalTo(true))
      .valueChanges();
  }

  getEventNews(clientId: string, eventId: string) {
    this.utilities.consoleDecorator('News event: ', eventId);
    return this.database.list<INew>(`/Clients/${clientId}/Events/${eventId}/News`, ref => ref.orderByChild('state').equalTo(true))
      .valueChanges();
  }

  getClientStaffs(clientId: string) {
    return this.database.list<IStaffConfig>(`/ClientList/${clientId}/Staff`,
      ref => ref.orderByChild('state').equalTo(true)
    ).valueChanges();
  }

  getClientStaffsById(clientId: string, staffId: string) {
    return this.database.object<any>(`/ClientList/${clientId}/Staff/${staffId}`).valueChanges();
  }

  getEventStaffData(clientId: string, entityId: string, eventId: string) {
    return this.database.object<any>(`/Clients/${clientId}/Events/${eventId}/Staff/${entityId}`)
      .valueChanges();
  }

  getClientStaff(clientId: string, staffId: string) {
    return this.database.object<IStaffConfig>(`/ClientList/${clientId}/Staff/${staffId}`).valueChanges();
  }

  getComercialSampleEvent(clientId: string, entityId: string, eventId: string) {
    return this.database.object<any>(`/Clients/${clientId}/Events/${eventId}/CommercialSamples/${entityId}`)
      .valueChanges();
  }

  getComercialClient(clientId: string, entityId: string) {
    return this.database.object<any>(`/Clients/${clientId}/CommercialSamples/${entityId}`)
      .valueChanges();
  }

  /**
   * Get active client staff Information
   * @param eventId
   * @author Sebastián Guevara
   */
  public getClientStaffsInformation() {
    return this.database.list<IStaffConfig>(`/ClientList/${ENV.client}/Staff`,
      ref => ref.orderByChild('state').equalTo(true)
    ).valueChanges();
  }

  public getStaffInformationById(staffId: string): Observable<any> {
    return this.database.object(`Clients/${ENV.client}/Staff/${staffId}`)
      .valueChanges();
  }

  getEventStaffs(clientId: string, eventId: string) {
    return this.database.list<IStaffConfig>(`/Clients/${clientId}/Events/${eventId}/Staff`,
      ref => ref.orderByChild('state').equalTo(true)
    ).valueChanges();
  }

  getEventStaff(clientId: string, eventId: string, staffId: string) {
    return this.database.object<IStaffConfig>(`/Clients/${clientId}/Events/${eventId}/Staff/${staffId}`).valueChanges();
  }

  /**
   * Get active event staff Information
   * @param eventId
   * @author Sebastián Guevara
   */
  public getEventStaffsInformation(eventId: string) {
    return this.database.list<IStaffConfig>(`/Clients/${ENV.client}/Events/${eventId}/Staff`,
      ref => ref.orderByChild('state').equalTo(true)
    ).valueChanges();
  }

  getStaffData(clientId: string, staffId: string) {
    return this.database.object<IStaffData>(`/Clients/${clientId}/Staff/${staffId}`)
      .valueChanges();
  }

  getCategorieStaffData(clientId: string, categorieId: string) {
    return this.database.object<IStaffData>(`/Clients/${clientId}/StaffCategories/${categorieId}`)
      .valueChanges();
  }

  getStaffDataObj(clientId: string, staffId: string) {
    return this.database.object<IStaffData>(`/Clients/${clientId}/Staff/${staffId}`)
      .valueChanges();
  }

  getReserveSelected(clientId: string, reserveId: string, calendarId: string = null) {
    return this.database.object<any>(`/Clients/${clientId}/Reserves/${reserveId}`)
      .valueChanges();
  }

  getAgendas(clientId: string, eventId: string) {
    return this.database.list<IAgenda>(`/Clients/${clientId}/Events/${eventId}/Diary`)
      .valueChanges()
      .map(list => list.filter(el => el.state));
  }

  getAgendaById(clientId: string, eventId: string, agendaId: string) {
    return this.database.object(`/Clients/${clientId}/Events/${eventId}/Diary/${agendaId}`).valueChanges();
  }

  compareUserAccessEvent(clientId: string, eventId: string, userEmail: string) {
    return this.afs.collection(clientId).doc('reserve_private').collection(eventId)
      .ref
      .where('email', '==', userEmail).where('state', '==', true).limit(1)
      .get();
  }

  compareCodeAccessEvent(clientId: string, eventid: string, codeEnter: string) {
    return this.afs.collection(clientId).doc('reserve_private').collection(eventid)
      .ref
      .where('code', '==', codeEnter).limit(1)
      .get();
  }

  async userEntryEvent(userId: string, eventId: string) {
    const obj = {
      userId,
      eventId,
      state: true,
      timestamp: firebase.database.ServerValue.TIMESTAMP,
    };
    const alreadyEnter = await this.database.object(`/Clients/${ENV.client}/UserEvents/${userId}/${eventId}`)
      .query.once('value').then(snap => snap.val());
    if (!alreadyEnter) {
      await this.database.object(`/Clients/${ENV.client}/UserEvents/${userId}/${eventId}`).update(obj);
      await this.database.object(`/Clients/${ENV.client}/Events/${eventId}/Users/${userId}`).update(obj);
      await this.database.object(`/Clients/${ENV.client}/EventStats/${eventId}/users_registered`)
        .query.ref.transaction(val => {
          if (!val) return 1;
          return val + 1;
        })
    }
  }

  getEventPermissionsSnap(clientId: string, eventId: string) {
    return this.database.object(`/Clients/${clientId}/EventList/${eventId}`)
      // .valueChanges();
      .query.once('value').then(snap => snap.val());
  }

  getUserReserves(clientId: string, userId: string) {
    return this.database.list(`/Clients/${clientId}/UserReserves/${userId}`)
      .valueChanges();
  }

  getReserve(clientId: string, reserveId: string) {
    return this.database.object(`/Clients/${clientId}/Reserves/${reserveId}`)
      .valueChanges();
  }

  getUserReserveSnapById(clientId: string, userId: string, reserveId: string) {
    return this.database.object(`/Clients/${clientId}/UserReserves/${userId}`)
      .query.once('value').then(snap => snap.val());
  }

  saveUserReserveWithCalendar(clientId: string, reserveId: string, calendarId: string, userId: string) {
    return this.database.object(`/Clients/${clientId}/UserReserves/${userId}/${reserveId}/${calendarId}`)
      .set(true);
  }

  saveUserReserve(clientId: string, reserveId: string, userId: string) {
    return this.database.object(`/Clients/${clientId}/UserReserves/${userId}/${reserveId}`)
      .update({
        id: reserveId,
        state: true,
        timestamp: firebase.database.ServerValue.TIMESTAMP,
      });
  }

  addReserveQuota(clientId: string, reserveId: string) {
    return firebase.database().ref(`/Clients/${clientId}/Reserves/${reserveId}/numReserves`)
      .transaction(val => val += 1);
  }

  addCalendarQuota(clientId: string, reserveId: string, calendarId: string) {
    return this.database.object(`/Clients/${clientId}/Reserves/${reserveId}/calendar/${calendarId}/numReserves`)
      .query.ref.transaction(val => ((parseInt(val) + 1) + ''));
  }

  getEventResources(clientId: string, eventId: string) {
    return this.database.list(`/Clients/${clientId}/Events/${eventId}/Resources`, ref => ref.orderByChild('state').equalTo(true))
      .valueChanges();
  }

  getResources(clientId: string) {
    return this.database.list(`/Clients/${clientId}/Resources`, ref => ref.orderByChild('state').equalTo(true))
      .valueChanges();
  }

  addResourceClientView(clientId: string, resourceId: string) {
    return this.database.object(`/Clients/${clientId}/Resources/${resourceId}/numViews`)
      .query.ref.transaction(val => {
        if (val) return (parseInt(val) + 1) + '';
        return 1;
      });
  }

  addResourceEventView(clientId: string, eventId: string, resourceId: string) {
    return this.database.object(`/Clients/${clientId}/Events/${eventId}/Resources/${resourceId}/numViews`)
      .query.ref.transaction(val => {
        if (val) return (parseInt(val) + 1) + '';
        return 1;
      });
  }

  getCountdown(clientId: string, eventId: string) {
    return this.database.object<ICountdown>(`/Clients/${clientId}/Events/${eventId}/Countdown`)
      .valueChanges();
  }

  plusEventUserStat(eventId: string) {
    return this.database.object(`/Clients/${ENV.client}/EventStats/${eventId}/users_registered`)
      .query.ref.transaction(val => {
        if (!val) return 1;
        return val + 1;
      })
  }

  authGuard(): Promise<boolean> {
    return this.afAuth.authState
      .take(1)
      .map((user) => {
        if (!user) {
          window.location.href = '/';
          // this.navCtrl.setRoot('room', {}, { animate: true, direction: 'forward' })
        }
        return user ? true : false;
      })
      .toPromise();
  }

}
// end file



// WEBPACK FOOTER //
// ./src/providers/event.ts